<template>
    <div>
        <div class="w3-container zero tabs-container flow-main-content">
            <div class="w3-row cursor-pointer w3-center flow-margin-top w3-margin-bottom flow-padding-top flow-padding-bottom tabs-container-head">
                <div class="w3-show-inline-block w3-margin-right"
                     @click="currentTabIndex = 0"
                     v-bind:class="currentTabIndex === 0 ? 'active' : 'inactive'">
                    <i class="fa fa-user-md w3-large flow-margin-right"></i>
                    <span class="flow-margin-left">{{$t("consultationRooms")}}</span>
                </div>
                <span class="divider">|</span>
                <div class="w3-show-inline-block w3-margin-right w3-margin-left"
                     @click="currentTabIndex = 1"
                     v-bind:class="currentTabIndex === 1 ? 'active' : 'inactive'">
                    <i class="fa fa-x-ray w3-large flow-margin-right"></i>
                    <span class="flow-margin-left">{{$t("examinationRooms")}}</span>
                </div>
            </div>

            <div class="w3-row flow-margin-top flow-padding-top w3-animate-opacity">
                <div class="zero-left flow-padding-top flow-form-inline-input w-100pc">

                    <!--CONSULTATION ROOMS -->
                    <div v-show="currentTabIndex === 0"
                         class="w3-container w3-animate-opacity">
                        <ConsultationsInWard></ConsultationsInWard>
                    </div>

                    <!--SHARED ROOMS -->
                    <div v-show="currentTabIndex === 1"
                         class="w3-container w3-animate-opacity">
                        <SharedRoomConsultationsInWard></SharedRoomConsultationsInWard>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import ConsultationsInWard from "../consultation/ConsultationsInWard";
    import SharedRoomConsultationsInWard from "../consultation/SharedRoomConsultationsInWard";
    import ContentHeader from "../common/ContentHeader";

    const frc = Vue.prototype.$frc;

    export default {
        name: "ConsultationsOverview",
        props: ['propsPhysician'],
        components: {ConsultationsInWard, SharedRoomConsultationsInWard, ContentHeader},
        data() {
            return {
                currentTabIndex: 0
            }
        }
    }
</script>

<style scoped>

</style>